import React, { useEffect, useState } from 'react'
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { gettoken } from '../../Localstorage/Store';
import { useSelector } from "react-redux";
import Accountprice from '../../utils/Accountprice';

export const SaveCartList = () => {
  const { bgColor, textColor } = useSelector((state) => state.theam);




  const nvg = useNavigate()
  const tokenvalue = gettoken();
  const [data, setData] = useState([]);
  const [error, seterror] = useState("No cart record found !");
  const [datastatus, setDatastatus] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [loading, setloading] = useState(false)
  const [filters, setFilters] = useState({
    order_number: "",
    cartStatus: "",
    startDate: "",
    endDate: "",
  });


  const clearFilter = () => {
    setSelectedStatuses([]); 
    setSelectedDuration(null);
    fetchCarts() 
   };

  useEffect(() => {
    async function fetchstatus() {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      let url = `${process.env.REACT_APP_API_URL}my_api/ordersstatus/`;

      const response = await axios.get(url, config);
      setDatastatus(response.data);
    }
    fetchstatus()

   }, [])


   
  const [searchTerm, setSearchTerm] = useState('');
  const handleSearch = async () => {
  if(searchTerm == ''){
    fetchCarts()
  }else{
    const searchTermLower = searchTerm.trim().toLowerCase();

      const filteredCarts = data.filter(order =>
        order.number.toLowerCase().includes(searchTermLower)
      );
      setData(filteredCarts)

      console.log('Filtered orders:', filteredCarts);
      if (data.length > 0 && selectedDuration) {
        if (selectedDuration == '360') {
          const errorMessage = "No orders found last one year "
          seterror(errorMessage);

        }   if (selectedDuration == '180') {
          const errorMessage = "No orders found last six Month "
          seterror(errorMessage);

        }
        if (selectedDuration == '30') {
          const errorMessage = "No orders found last 30 Days "
          seterror(errorMessage);

        }
        if (selectedDuration == '15') {
          const errorMessage = "No orders found last 15 Days "
          seterror(errorMessage);

        }
    
        
      
      }
  } 
  };

  const handleStatusChange = async (status) => {
    const updatedStatuses = selectedStatuses.includes(status)
      ? selectedStatuses.filter(s => s !== status)
      : [...selectedStatuses, status];
    setSelectedStatuses(updatedStatuses);
    await sendDataToBackend(updatedStatuses, selectedDuration);
  };
  const handleCheckboxChange = async (duration) => {
    setSelectedDuration(duration);
    await sendDataToBackend(selectedStatuses, duration); 
  };
  const sendDataToBackend = async (statuses, duration) => {
    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
      },
    };
    const url = `${process.env.REACT_APP_API_URL}my_api/orders/`; 
    const response = await axios.post(url, { operations: statuses, duration: duration }, config); 

    console.log("response from backend:", response);
    setData(response.data);
  };


  async function fetchCarts({ order_number, cartStatus, startDate, endDate }) {
    setloading(true);
    
    const config = {
      headers: {
        Authorization: `Bearer ${tokenvalue.access}`,
      },
    };
  
    let queryParams = new URLSearchParams();
    if (order_number) queryParams.append("order_number", order_number);
    if (cartStatus) queryParams.append("status", cartStatus);
    if (startDate) queryParams.append("date_from", startDate);
    if (endDate) queryParams.append("date_to", endDate);
  
    let url = `${process.env.REACT_APP_API_URL}bulk/bulk-orders-save/?${queryParams.toString()}`;
  
    try {
      const response = await axios.get(url, config);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching cart list:", error);
    } finally {
      setloading(false);
    }
  }
  
  useEffect(() => {
    fetchCarts({}); 
  }, []);
  


  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleFilter = () => {
    fetchCarts(filters);
  };

  
  return (
    <div>
      <Header />

      <div>
        {/* breadcrumb start */}
        <div className="breadcrumb-main marginfromtop" style={{ background: "#fff" }}>
          <div className="container m-0">
            <div className="row">
              <div className="col">
                <div className="breadcrumb-contain">
                  <div>
                    <ul>
                      <li><a href="/home">home</a></li>
                      <li>{`>`}</li>
                      <li><a href="javascript:void(0)">Saved Carts </a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* breadcrumb End */}
        <div>
          <section className="section-big-pt-space py-1 " style={{ background: "#f9f9f9" }}>
            <div className="col-lg-12 col-sm-12 col-xs-12 mt-lg-4 mt-xs-4 mb-5">

              <div className="container-fuild emp-profile">
                <div className="row pro">


                   <div className="row py-xl-4 py-3 d-flex justify-content-center" >



                    <div className={ "col-xl-9 col-md-12 Ohistory "} style={{ padding: "0px 4px" }} >
                      <div className=" mb-3 justify-content-center" style={{ gap: '10px',alignItems:'end' }}>
                        <div className="row">
                          <div className="col-md-10 col-12">
                            <div className="row">
                       <div className='col-md-3 col-12'>
                        <label htmlFor="" className='m-0' style={{fontWeight:'500',fontSize:'13px'}}>
                          Cart ID 
                        </label>
                       <input
                          type="text"
                          name="order_number"
                          style={{ borderRadius: "0px",fontSize:'12px',color:"#8F9091" }}
                          className="form-control newborder"
                          placeholder="Cart ID"
                          value={filters.order_number}
                          onChange={handleChange}
                        />
                       </div>
                       <div  className='col-md-3 col-12'>
                       <label htmlFor="" className='m-0' style={{fontWeight:'500',fontSize:'13px'}}>
                          Cart Status 
                        </label>
                        <select name="cartStatus"
                        className="form-control newborder"
                        style={{ borderRadius: "0px",fontSize:'12px',color:"#8F9091" }}
                        value={filters.cartStatus} onChange={handleChange}>
         
            <option value="" >
            Select Cart Status
            </option>
            <option value="Saved_Cart" >
            Saved Cart
            </option>
            <option value="Saved_Cart_Approved" >
            Cart Updated
            </option>
            <option value="Saved_Cart_Order_Created" >
            Confirmed
            </option>
        </select>
                       </div>
                       <div  className='col-md-3 col-12'>
                       <label htmlFor="" className='m-0' style={{fontWeight:'500',fontSize:'13px'}}>
                          Start Date 
                        </label>
                       <input
                          type="date"
                          name="startDate"
                          style={{ borderRadius: "0px",fontSize:'12px',color:"#8F9091" }}
                          className="form-control "
                          placeholder="Start Date"
                          value={filters.startDate}
                          onChange={handleChange}
                        />
                       </div>
                       <div  className='col-md-3 col-12'>
                       <label htmlFor="" className='m-0' style={{fontWeight:'500',fontSize:'13px'}}>
                          End Date 
                        </label>
                       <input
                          type="date"
                          style={{ borderRadius: "0px",fontSize:'12px',color:"#8F9091" }}
                          name="endDate"
                          className="form-control "
                          placeholder="End Date"
              
                          value={filters.endDate}
                          onChange={handleChange}
                        />
                       </div>
                       </div>
                       </div>
                       <div className="col-md-2 col-12 d-flex align-items-end">
                       <button
                          className='Sbtn btn btn-outline-secondary mt-md-0 mt-3'
                          style={{ backgroundColor: `#${bgColor}`, color: 'white', borderRadius: '0px',height:'fit-content', fontSize: "13px",width:'100%' }}
                          type="button"
                          onClick={handleFilter} >
                         Filter
                        </button>
                       </div>
                       <div>
                        
                        
                        
                        </div>
                       </div>
                     
                      </div>
                      

                      <div className="table-responsive customoverflow" >
                        <table className="table  orstatus" >

                          {/* <table className="table"> */}
                          <thead>
                            <tr>
<th></th>
<th></th>
                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>S.No</div></th>
                              

                             

<th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Cart Id</div></th>
                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Amount</div></th>


<th scope="col" style={{width:"20%",position:'relative'}}><div style={{
                                fontWeight: 600, fontSize: "12px", display: "flex",alignItems:'end',
                                WebkitLineClamp: "1",
                                background:'#fff',
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}> <p style={{height:'fit-content',fontSize:'12px'}}> Created Date <label htmlFor="daydropdown" style={{margin:'0px'}} 
                              >
                                </label></p></div>   
                              </th>
                              <th scope="col"style={{position:'relative'}} ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                display: "flex",alignItems:'end',
                                WebkitLineClamp: "1",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}> <p style={{height:'fit-content',fontSize:'12px'}} > Status <label htmlFor="daydropdown" style={{margin:'0px'}}>
                               </label> </p></div>
                              </th>
                            
                            </tr>
                          </thead>
                          {/* </table> */}



                          <thead className="table-light" style={{ paddingTop: '20px' }}>
                            <tr>

                            </tr>
                          </thead>
                          <tbody >
                            {data[0] ? (data.map((item, index) => (
                              <tr  key={index}>
<td></td>
<td></td>

                                <td style={{ color: '#230BB3', paddingTop: '20px', fontSize: '12px' }}>

                                  <h5 style={{ fontSize: "12px", lineHeight: "22px",cursor:'pointer',position:'relative',left:'7px' }}> {index + 1}</h5>
                                </td>

                               
                                <td style={{ color: '#230BB3', paddingTop: '20px', fontSize: '12px' }}>

                                  <h5 onClick={() => { item.status == "Saved_Cart_Approved" ? nvg(`/saved-cart-pay/${item.order_number}`) : nvg(`/saved-cart-detail/${item.order_number}`) }} style={{ fontSize: "12px", lineHeight: "22px",color: `#${textColor}`,cursor:'pointer' }}> {item.order_number}</h5>
                                </td>
                               





                      <td style={{ paddingTop: '20px', fontSize: '12px' }}>
                                  {/* ₹ */}
                                  {Accountprice(item.total_incl_tax)}</td>


                                  <td style={{ paddingTop: '20px', fontSize: '12px', }}> <p className='superwidth234' style={{margin:'0px',padding:'0px',fontSize: '12px'}}> {new Date(item?.order_date.split('Time')[0]).toLocaleDateString('en-GB', {
                                  hour: 'numeric',
                                  minute: 'numeric'
                                }


                                )}</p></td>


                                <td>
                                  <p style={{ paddingTop: '11px', fontSize: '12px' }} className='superwidth234'> 
              
                                    {item.status == "Saved_Cart" ? "Saved Cart" : ""}
                                    {item.status == "Saved_Cart_Approved" ? "Cart Updated" : ""}
                                    {item.status == "Saved_Cart_Rejected" ? "Saved Cart Rejected" : ""}
                                    {item.status == "BULK_SAVED_CART_ORDER_CREATED" ? "Confirmed" : ""}
                                              {/* {item.status.charAt(0).toUpperCase() + item.status.slice(1)} */}
                                  </p>
                                </td>
                                {/* <td>
                                  <p style={{ paddingTop: '15px', fontSize: '12px',color:'#230bb3',fontWeight:'700' }} onClick={() => { nvg(`/tracksingleorder/${item.order_number}`) }}> Track </p>
                                </td> */}

                              </tr>
                            ))) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  className="text-center"
                                  style={{ fontWeight: "500" }}
                                >
                                  {error}
                                </td>
                              </tr>
                            )}



                          </tbody>
                        </table>
                      </div>

                    </div>

                  </div>






                </div>
              </div>
            </div>
          </section>

        </div>



        <Footer />
      </div>


    </div>
  )
}


const dropdownStyle = {
  listStyle: 'none',
  margin: 0,
  padding: '10px',
  backgroundColor: '#fff',
  fontSize:'12px',
  border: '1px solid #ccc',
  position: 'absolute',
  top: '100%',
  left: 0,
  width: '150px',
  zIndex: 1,
  cursor: 'pointer',
};
export default SaveCartList;
